/* MV Sortiment assets/mv-sortiment.hilfe.js - Agent H-A - 2026-10-06
 *
 * Hilfe-Center (sections/mv-hilfe-anleitung.liquid, sections/mv-hilfe-hub.liquid; Spezifikation _docs/h-hilfe.md).
 * Anleitung, Wurzel [data-mv-hilfe="<handle>"] mit data-mv-hilfe-schritte und data-mv-hilfe-titel:
 *  1. Fortschritt je Anleitung in localStorage unter "mv-hilfe:<handle>" als {"v":1,"erledigt":[1,3],"haken":["vorab-1"]};
 *     ohne nutzbaren Speicher (privater Modus, gesperrt) gilt er nur fuer die geoeffnete Seite.
 *  2. Knopf [data-mv-hilfe-erledigt="N"] (aria-pressed) schaltet Schritt N um; Checklisten [data-mv-hilfe-haken] merken
 *     sich ihren Haken. Schritt-Karte, Leiste, Ring, Stand, Startknopf, Anfrage-Text (data-konfiguration) und
 *     Fertig-Karte folgen dem Stand; eine aria-live-Zeile [data-mv-hilfe-ansage] sagt die Aenderung an.
 *  3. Weiter/Zurueck [data-mv-hilfe-gehe], Leiste [data-mv-hilfe-leiste-ziel] und Start [data-mv-hilfe-start] scrollen
 *     zum Ziel (sanft, ausser bei reduzierter Bewegung) und setzen den Fokus auf dessen Ueberschrift (tabindex -1).
 *  4. Die Leiste markiert den sichtbaren Abschnitt (aria-current="step", nur mit IntersectionObserver) und schiebt ihn
 *     mobil in die Mitte der waagrechten Liste [data-mv-hilfe-leiste-liste].
 *  5. [data-mv-hilfe-drucken] und beforeprint klappen die Probleme auf, afterprint stellt den Zustand wieder her.
 *  6. Ein Anker #problem-... klappt das Problem auf (beim Laden und bei hashchange).
 *  7. [data-mv-hilfe-zuruecksetzen] loescht den Stand der Anleitung.
 * Hub, Wurzel [data-mv-hilfe-hub]:
 *  8. Suche [data-mv-hilfe-suche] ueber den Text jeder Karte [data-mv-hilfe-karte] (Kicker, Titel, Teaser, Geraete,
 *     Schritt-Titel); alle Woerter muessen vorkommen, Umlaute, Akzente und Satzzeichen zaehlen nicht. Passende
 *     Schritt-Titel zeigt die Liste [data-mv-hilfe-karte-treffer]. Geraetefilter [data-mv-hilfe-geraet] (aria-pressed)
 *     nach data-mv-hilfe-gruppen der Karte; Status [data-mv-hilfe-treffer], Leerzustand [data-mv-hilfe-leer],
 *     [data-mv-hilfe-alles] hebt Suche und Filter auf. ?suche=... belegt das Feld vor. Kein Fetch, keine Analytics.
 *  9. Fortschritt "n von m erledigt" auf den Karten [data-mv-hilfe-karte-fortschritt] aus localStorage.
 * Paket T-1 (2026-10-07, Querpruefung R-1, Abschnitt 5): Haken und Farbe zeigen "erledigt" in der Leiste nur optisch;
 *     erledigte Eintraege bekommen deshalb einen verborgenen Zusatz ", erledigt" (span.mv-visually-hidden mit
 *     data-mv-zustand-zusatz, entsteht hier), die Ziffer bleibt im Namen (hilfe.css verdeckt sie nur optisch).
 * Delegation auf document; shopify:section:load startet neu. Laedt allein und in beliebiger Reihenfolge als Teil von
 * assets/mv-sortiment.js (_build/konkat.sh). Unter Node (Tests) liefert die Datei nur die reinen Funktionen.
 * Kommentare und Datei ASCII; sichtbare Texte als \u-Escapes.
 * Paket M-6b (2026-10-12, Mobil-Optimierungsrunde, _docs/m6b-hubs-mobil.md): Unter 700 px (matchMedia MOBIL, gleiche
 *     Grenze wie der Nachtrag M-6b in hilfe.css) werden die Themen des Hubs zu Klappbereichen: Die Ueberschrift
 *     bekommt einen Knopf (aria-expanded, aria-controls auf die Kartenliste, die dafuer eine id bekommt) mit der Zahl
 *     der Anleitungen; zu = Kartenliste hidden; der Hub traegt data-mv-hilfe-klapp. Offen ist beim Start das erste
 *     Thema oder das Thema aus dem Anker #hilfe-<thema>; Kacheln und Anker-Links oeffnen ihr Thema vor dem Sprung,
 *     Suche und Geraetefilter oeffnen Themen mit Treffern und stellen danach den Stand von vorher wieder her
 *     (klappFolge), Enter im Suchfeld springt zum ersten Treffer, Druck klappt alles auf. Suche, Filter und Fortschritt
 *     bleiben unveraendert. Neue Haken nur als Attribute, die das Skript selbst setzt und nie per Selektor sucht.
 *     Ab 700 px und ohne matchMedia aendert das Skript nichts; beim Wechsel ueber die Grenze baut es das Markup zurueck.
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-07.1';
  var PRAEFIX = 'mv-hilfe:';
  var VERZOEGERUNG = 120;
  // Paket M-6b: Grenze der mobilen Darstellung (assets/mv-sortiment.hilfe.css, Nachtrag M-6b)
  var MOBIL = '(max-width: 699.98px)';

  var TEXT = {
    keinSchritt: 'Noch kein Schritt erledigt',
    vonSchritten: '{n} von {m} Schritten erledigt',
    alle: 'Alle Schritte erledigt',
    karte: '{n} von {m} erledigt',
    starten: 'Anleitung starten',
    weiter: 'Weiter mit Schritt {n}',
    ansehen: 'Anleitung ansehen',
    anfrage: 'Anleitung: {t}',
    anfrageStand: ' \u00b7 Erledigt: {n} von {m} Schritten',
    erledigt: 'Schritt {n} erledigt',
    erledigtZusatz: ', erledigt',
    offen: 'Schritt {n} wieder offen',
    zurueck: 'Fortschritt zur\u00fcckgesetzt',
    keine: 'Keine passende Anleitung gefunden',
    eine: '1 Anleitung gefunden',
    mehrere: '{n} Anleitungen gefunden'
  };

  // ===========================================================================================
  // Teil 1: reine Logik
  // ===========================================================================================

  function leererStand() {
    return { v: 1, erledigt: [], haken: [] };
  }

  function schluessel(handle) {
    return PRAEFIX + String(handle == null ? '' : handle);
  }

  // Gespeicherten Text lesen; alles Unbekannte faellt weg (nur ganze Schritte ab 1, Haken-Schluessel a-z0-9-)
  function leseStand(roh) {
    var s = leererStand();
    if (typeof roh !== 'string' || !roh) return s;
    var d;
    try { d = JSON.parse(roh); } catch (e) { return s; }
    if (!d || typeof d !== 'object') return s;
    var i;
    if (Object.prototype.toString.call(d.erledigt) === '[object Array]') {
      for (i = 0; i < d.erledigt.length; i++) {
        var n = d.erledigt[i];
        if (typeof n === 'number' && n > 0 && Math.floor(n) === n && s.erledigt.indexOf(n) === -1) s.erledigt.push(n);
      }
      s.erledigt.sort(function (a, b) { return a - b; });
    }
    if (Object.prototype.toString.call(d.haken) === '[object Array]') {
      for (i = 0; i < d.haken.length; i++) {
        var k = d.haken[i];
        if (typeof k === 'string' && /^[a-z0-9-]+$/.test(k) && s.haken.indexOf(k) === -1) s.haken.push(k);
      }
    }
    return s;
  }

  function standText(stand) {
    return JSON.stringify({ v: 1, erledigt: stand.erledigt, haken: stand.haken });
  }

  // Schritt n umschalten; liefert einen neuen Stand (sortiert)
  function umschalten(stand, n) {
    var erledigt = stand.erledigt.slice();
    var i = erledigt.indexOf(n);
    if (i === -1) erledigt.push(n);
    else erledigt.splice(i, 1);
    erledigt.sort(function (a, b) { return a - b; });
    return { v: 1, erledigt: erledigt, haken: stand.haken.slice() };
  }

  function setzeHaken(stand, key, an) {
    var haken = stand.haken.slice();
    var i = haken.indexOf(key);
    if (an && i === -1) haken.push(key);
    if (!an && i !== -1) haken.splice(i, 1);
    return { v: 1, erledigt: stand.erledigt.slice(), haken: haken };
  }

  function anzahlErledigt(stand, gesamt) {
    var n = 0;
    for (var i = 0; i < stand.erledigt.length; i++) if (stand.erledigt[i] >= 1 && stand.erledigt[i] <= gesamt) n++;
    return n;
  }

  function prozent(n, gesamt) {
    return gesamt > 0 ? Math.round((n * 100) / gesamt) : 0;
  }

  function fortschrittText(n, gesamt) {
    if (n <= 0) return TEXT.keinSchritt;
    if (gesamt > 0 && n >= gesamt) return TEXT.alle;
    return TEXT.vonSchritten.replace('{n}', String(n)).replace('{m}', String(gesamt));
  }

  function kartenText(n, gesamt) {
    if (gesamt > 0 && n >= gesamt) return TEXT.alle;
    return TEXT.karte.replace('{n}', String(n)).replace('{m}', String(gesamt));
  }

  // Erster offener Schritt (1 bis gesamt), 0 wenn alle erledigt sind
  function naechsterSchritt(stand, gesamt) {
    for (var i = 1; i <= gesamt; i++) if (stand.erledigt.indexOf(i) === -1) return i;
    return 0;
  }

  function startText(stand, gesamt) {
    if (anzahlErledigt(stand, gesamt) === 0) return TEXT.starten;
    var n = naechsterSchritt(stand, gesamt);
    return n ? TEXT.weiter.replace('{n}', String(n)) : TEXT.ansehen;
  }

  // Text fuer die Anfrage-Lightbox (data-konfiguration): Anleitung und, wenn begonnen, der Stand
  function anfrageText(titel, n, gesamt) {
    var s = TEXT.anfrage.replace('{t}', String(titel == null ? '' : titel));
    if (n > 0) s += TEXT.anfrageStand.replace('{n}', String(n)).replace('{m}', String(gesamt));
    return s;
  }

  function trefferText(n, aktiv) {
    if (!aktiv) return '';
    if (n === 0) return TEXT.keine;
    if (n === 1) return TEXT.eine;
    return TEXT.mehrere.replace('{n}', String(n));
  }

  // Vergleichsform: klein, ohne Akzente, Umlaut-Umschrift zusammengefuehrt, nur a-z und 0-9 mit Leerzeichen
  function normalisiere(text) {
    var s = String(text == null ? '' : text).toLowerCase();
    if (typeof s.normalize === 'function') s = s.normalize('NFD');
    return s
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\u00df/g, 'ss')
      .replace(/ae/g, 'a')
      .replace(/oe/g, 'o')
      .replace(/ue/g, 'u')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/^ +| +$/g, '');
  }

  function woerter(eingabe) {
    var teile = normalisiere(eingabe).split(' ');
    var aus = [];
    for (var i = 0; i < teile.length; i++) if (teile[i] && aus.indexOf(teile[i]) === -1) aus.push(teile[i]);
    return aus;
  }

  function passt(heu, suchwoerter) {
    for (var i = 0; i < suchwoerter.length; i++) if (heu.indexOf(suchwoerter[i]) === -1) return false;
    return true;
  }

  // ---------------------------------------------- Klappbereiche mobil (Paket M-6b, gleich wie downloads.js)

  // Menge als Objekt {id: true}; alles andere faellt weg
  function menge(o) {
    var aus = {};
    if (o && typeof o === 'object') for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k) && o[k] === true) aus[k] = true;
    return aus;
  }

  function klappKopie(stand) {
    var s = stand || {};
    return { zu: menge(s.zu), vorher: s.vorher ? menge(s.vorher) : null, treffer: menge(s.treffer), manuell: !!s.manuell };
  }

  // Startzustand: offen ist das Ziel (Anker), sonst das erste Thema
  function startOffen(ids, ziel) {
    var l = Object.prototype.toString.call(ids) === '[object Array]' ? ids : [];
    if (ziel && l.indexOf(ziel) !== -1) return [ziel];
    return l.length ? [l[0]] : [];
  }

  // Stand {zu, vorher, treffer, manuell}: zu = eingeklappte Themen. Waehrend Suche oder Filter (aktiv) gehen Themen auf,
  // die neu Treffer haben (treffer = {id: true|false}), selbst Zugeklapptes bleibt zu. Endet die Suche, gilt wieder der
  // Stand von vorher - ausser die Person hat zwischendurch selbst geklappt (manuell).
  function klappFolge(stand, treffer, aktiv) {
    var neu = klappKopie(stand);
    if (aktiv) {
      if (!neu.vorher) {
        neu.vorher = menge(neu.zu);
        neu.treffer = {};
        neu.manuell = false;
      }
      for (var k in treffer) {
        if (!Object.prototype.hasOwnProperty.call(treffer, k)) continue;
        if (treffer[k] && !neu.treffer[k]) delete neu.zu[k];
        if (treffer[k]) neu.treffer[k] = true;
        else delete neu.treffer[k];
      }
    } else if (neu.vorher) {
      if (!neu.manuell) neu.zu = neu.vorher;
      neu.vorher = null;
      neu.treffer = {};
      neu.manuell = false;
    }
    return neu;
  }

  // Knopf: Thema id auf- oder zuklappen; waehrend einer Suche zaehlt das als selbst geklappt
  function klappUmschalten(stand, id) {
    var neu = klappKopie(stand);
    if (neu.zu[id]) delete neu.zu[id];
    else neu.zu[id] = true;
    if (neu.vorher) neu.manuell = true;
    return neu;
  }

  var api = {
    VERSION: VERSION,
    TEXT: TEXT,
    schluessel: schluessel,
    leererStand: leererStand,
    leseStand: leseStand,
    standText: standText,
    umschalten: umschalten,
    setzeHaken: setzeHaken,
    anzahlErledigt: anzahlErledigt,
    prozent: prozent,
    fortschrittText: fortschrittText,
    kartenText: kartenText,
    naechsterSchritt: naechsterSchritt,
    startText: startText,
    anfrageText: anfrageText,
    trefferText: trefferText,
    normalisiere: normalisiere,
    woerter: woerter,
    passt: passt,
    MOBIL: MOBIL,
    startOffen: startOffen,
    klappFolge: klappFolge,
    klappUmschalten: klappUmschalten
  };

  // Node (Tests): nur hier gibt es module.exports, im Browser nie
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = api;
    return;
  }

  // ===========================================================================================
  // Teil 2: Browser
  // ===========================================================================================

  window.__mvSortiment = window.__mvSortiment || {};
  var MV = window.__mvSortiment;
  if (MV.hilfe) return;

  var speicherOk;
  var fluechtig = {};
  var heuSpeicher = typeof WeakMap === 'function' ? new WeakMap() : null;
  var zeitgeber = null;
  var druckZustand = null;
  // Paket M-6b: eine Abfrage fuer alle Hubs; ohne matchMedia bleibt alles wie ab 700 px
  var abfrage = typeof window.matchMedia === 'function' ? window.matchMedia(MOBIL) : null;

  function alle(bereich, selektor) {
    return Array.prototype.slice.call(bereich.querySelectorAll(selektor));
  }

  function setzeText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  // Verborgener Zusatz am Ende eines Links (Zustand fuer Screenreader, Paket T-1); leerer Text entfernt ihn
  function setzeZusatz(el, text) {
    if (!el) return;
    var z = el.querySelector('[data-mv-zustand-zusatz]');
    if (!text) {
      if (z) z.parentNode.removeChild(z);
      return;
    }
    if (!z) {
      z = document.createElement('span');
      z.className = 'mv-visually-hidden';
      z.setAttribute('data-mv-zustand-zusatz', '');
      el.appendChild(z);
    }
    setzeText(z, text);
  }

  function ruhig() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  // localStorage nur, wenn er sich lesen und schreiben laesst (privater Modus, gesperrte Cookies)
  function speicher() {
    if (speicherOk !== undefined) return speicherOk;
    speicherOk = null;
    try {
      var s = window.localStorage;
      if (s) {
        s.setItem('mv-hilfe:__probe', '1');
        s.removeItem('mv-hilfe:__probe');
        speicherOk = s;
      }
    } catch (e) {
      speicherOk = null;
    }
    return speicherOk;
  }

  function lade(handle) {
    var s = speicher();
    var roh = null;
    if (s) {
      try { roh = s.getItem(schluessel(handle)); } catch (e) { roh = null; }
    } else if (Object.prototype.hasOwnProperty.call(fluechtig, handle)) roh = fluechtig[handle];
    return leseStand(roh);
  }

  function sichere(handle, stand) {
    var text = standText(stand);
    var s = speicher();
    if (s) {
      try { s.setItem(schluessel(handle), text); return; } catch (e) { /* Speicher voll: nur fuer diese Seite */ }
    }
    fluechtig[handle] = text;
  }

  function vergiss(handle) {
    var s = speicher();
    if (s) {
      try { s.removeItem(schluessel(handle)); } catch (e) { /* nichts zu tun */ }
    }
    delete fluechtig[handle];
  }

  function wurzelVon(el) {
    return el && el.closest ? el.closest('[data-mv-hilfe]') : null;
  }

  function hubVon(el) {
    return el && el.closest ? el.closest('[data-mv-hilfe-hub]') : null;
  }

  function gesamtVon(w) {
    return parseInt(w.getAttribute('data-mv-hilfe-schritte'), 10) || 0;
  }

  function sage(w, text) {
    var a = w.querySelector('[data-mv-hilfe-ansage]');
    if (a) a.textContent = text;
  }

  // ------------------------------------------------------------------------------- Anleitung

  function anleitungAnwenden(w, stand) {
    var handle = w.getAttribute('data-mv-hilfe');
    var gesamt = gesamtVon(w);
    var s = stand || lade(handle);
    var n = anzahlErledigt(s, gesamt);
    var komplett = gesamt > 0 && n >= gesamt;

    alle(w, '[data-mv-hilfe-haken]').forEach(function (feld) {
      feld.checked = s.haken.indexOf(feld.getAttribute('data-mv-hilfe-haken')) !== -1;
    });
    alle(w, '[data-mv-hilfe-erledigt]').forEach(function (knopf) {
      var nr = parseInt(knopf.getAttribute('data-mv-hilfe-erledigt'), 10);
      var an = s.erledigt.indexOf(nr) !== -1;
      knopf.hidden = false;
      knopf.setAttribute('aria-pressed', an ? 'true' : 'false');
      var schritt = document.getElementById('schritt-' + nr);
      if (!schritt) return;
      if (an) schritt.setAttribute('data-mv-hilfe-zustand', 'erledigt');
      else schritt.removeAttribute('data-mv-hilfe-zustand');
      var status = schritt.querySelector('[data-mv-hilfe-status]');
      if (status) status.hidden = !an;
    });

    var vorab = alle(w, '[data-mv-hilfe-haken^="vorab-"]');
    var vorabFertig = vorab.length > 0 && vorab.every(function (f) { return f.checked; });
    alle(w, '[data-mv-hilfe-leiste-ziel]').forEach(function (a) {
      var ziel = a.getAttribute('data-mv-hilfe-leiste-ziel');
      var m = /^schritt-(\d+)$/.exec(ziel);
      var an = m ? s.erledigt.indexOf(parseInt(m[1], 10)) !== -1 : ziel === 'vorab' ? vorabFertig : ziel === 'fertig' ? komplett : false;
      if (an) a.setAttribute('data-mv-hilfe-zustand', 'erledigt');
      else a.removeAttribute('data-mv-hilfe-zustand');
      setzeZusatz(a, an ? TEXT.erledigtZusatz : '');
    });

    var p = prozent(n, gesamt);
    var ring = w.querySelector('[data-mv-hilfe-ring]');
    if (ring) {
      ring.hidden = false;
      ring.setAttribute('aria-valuenow', String(n));
      ring.setAttribute('aria-valuetext', fortschrittText(n, gesamt));
    }
    setzeText(w.querySelector('[data-mv-hilfe-prozent]'), p + '\u00a0%');
    var wert = w.querySelector('[data-mv-hilfe-ring-wert]');
    if (wert) wert.setAttribute('stroke-dashoffset', String(100 - p));
    setzeText(w.querySelector('[data-mv-hilfe-stand]'), fortschrittText(n, gesamt));

    var start = w.querySelector('[data-mv-hilfe-start]');
    if (start) {
      setzeText(start.querySelector('[data-mv-hilfe-start-text]'), startText(s, gesamt));
      start.setAttribute('href', '#schritt-' + (naechsterSchritt(s, gesamt) || 1));
    }
    var titel = w.getAttribute('data-mv-hilfe-titel') || '';
    alle(w, '[data-mv-hilfe-anfrage]').forEach(function (a) {
      a.setAttribute('data-konfiguration', anfrageText(titel, n, gesamt));
    });
    var druck = w.querySelector('[data-mv-hilfe-drucken]');
    if (druck) druck.hidden = false;
    var zurueck = w.querySelector('[data-mv-hilfe-zuruecksetzen]');
    if (zurueck) zurueck.hidden = !(s.erledigt.length || s.haken.length);
    var fertig = w.querySelector('[data-mv-hilfe-fertig]');
    if (fertig) {
      if (komplett) fertig.setAttribute('data-mv-hilfe-komplett', 'true');
      else fertig.removeAttribute('data-mv-hilfe-komplett');
    }
    var glueck = w.querySelector('[data-mv-hilfe-glueckwunsch]');
    if (glueck) glueck.hidden = !komplett;
  }

  function schrittUmschalten(w, nr) {
    var handle = w.getAttribute('data-mv-hilfe');
    var gesamt = gesamtVon(w);
    var neu = umschalten(lade(handle), nr);
    sichere(handle, neu);
    anleitungAnwenden(w, neu);
    var an = neu.erledigt.indexOf(nr) !== -1;
    if (an && gesamt > 0 && anzahlErledigt(neu, gesamt) >= gesamt) sage(w, TEXT.alle);
    else sage(w, (an ? TEXT.erledigt : TEXT.offen).replace('{n}', String(nr)));
  }

  function zuruecksetzen(w) {
    vergiss(w.getAttribute('data-mv-hilfe'));
    anleitungAnwenden(w, leererStand());
    sage(w, TEXT.zurueck);
    var ziel = document.getElementById('vorab-titel');
    if (ziel && typeof ziel.focus === 'function') ziel.focus();
  }

  // Sprung zu #ziel: scrollen, Fokus auf die Ueberschrift, Adresse ohne neuen Verlaufseintrag
  function springe(id) {
    var ziel = document.getElementById(id);
    if (!ziel) return false;
    if (ziel.matches && ziel.matches('details[data-mv-hilfe-problem]')) ziel.open = true;
    if (typeof ziel.scrollIntoView === 'function') ziel.scrollIntoView({ behavior: ruhig() ? 'auto' : 'smooth', block: 'start' });
    var kopf = document.getElementById(id + '-titel') || ziel;
    if (typeof kopf.focus === 'function') {
      try { kopf.focus({ preventScroll: true }); } catch (e) { kopf.focus(); }
    }
    try { window.history.replaceState(null, '', '#' + id); } catch (e) { /* ohne History-API */ }
    return true;
  }

  function vorDruck() {
    if (druckZustand) return;
    druckZustand = alle(document, 'details[data-mv-hilfe-problem]').map(function (d) {
      var vorher = d.open;
      d.open = true;
      return [d, vorher];
    });
  }

  function nachDruck() {
    if (!druckZustand) return;
    druckZustand.forEach(function (p) { p[0].open = p[1]; });
    druckZustand = null;
  }

  function oeffneAusHash() {
    var id = String(window.location.hash || '').replace(/^#/, '');
    if (!/^problem-[a-z0-9-]+$/.test(id)) return;
    var d = document.getElementById(id);
    if (d && d.matches && d.matches('details[data-mv-hilfe-problem]')) d.open = true;
  }

  // Sichtbarer Abschnitt -> aria-current="step" in der Leiste; mobil den Eintrag in die Mitte der Liste schieben
  function setzeAktuell(w, id) {
    alle(w, '[data-mv-hilfe-leiste-ziel]').forEach(function (a) {
      if (a.getAttribute('data-mv-hilfe-leiste-ziel') !== id) {
        a.removeAttribute('aria-current');
        return;
      }
      a.setAttribute('aria-current', 'step');
      var liste = a.closest('[data-mv-hilfe-leiste-liste]');
      if (!liste || liste.scrollWidth <= liste.clientWidth || !a.getBoundingClientRect) return;
      var r = a.getBoundingClientRect();
      var l = liste.getBoundingClientRect();
      var links = liste.scrollLeft + (r.left + r.width / 2) - (l.left + l.width / 2);
      if (typeof liste.scrollTo === 'function') liste.scrollTo({ left: links, behavior: ruhig() ? 'auto' : 'smooth' });
      else liste.scrollLeft = links;
    });
  }

  function beobachte(w) {
    if (typeof window.IntersectionObserver !== 'function') return;
    var ziele = alle(w, '[data-mv-hilfe-leiste-ziel]').map(function (a) {
      return document.getElementById(a.getAttribute('data-mv-hilfe-leiste-ziel'));
    }).filter(Boolean);
    if (!ziele.length) return;
    var beobachter = new window.IntersectionObserver(function (eintraege) {
      var oben = null;
      eintraege.forEach(function (e) {
        if (e.isIntersecting && (!oben || e.boundingClientRect.top < oben.boundingClientRect.top)) oben = e;
      });
      if (oben) setzeAktuell(w, oben.target.id);
    }, { rootMargin: '-30% 0px -60% 0px' });
    ziele.forEach(function (z) { beobachter.observe(z); });
  }

  function anleitungStarten(w) {
    anleitungAnwenden(w);
    beobachte(w);
    w.setAttribute('data-mv-hilfe-bereit', VERSION);
  }

  // ------------------------------------------------------------------------------- Hub

  function heuVon(karte) {
    var v = heuSpeicher ? heuSpeicher.get(karte) : karte.__mvHilfeHeu;
    if (v === undefined) {
      v = normalisiere(karte.textContent);
      if (heuSpeicher) heuSpeicher.set(karte, v);
      else karte.__mvHilfeHeu = v;
    }
    return v;
  }

  function anwenden(h) {
    var feld = h.querySelector('[data-mv-hilfe-suche]');
    var sw = woerter(feld ? feld.value : '');
    var filter = h.getAttribute('data-mv-hilfe-filter') || 'alle';
    var aktiv = sw.length > 0 || filter !== 'alle';
    var zahl = 0;
    alle(h, '[data-mv-hilfe-karte]').forEach(function (k) {
      var gruppen = (k.getAttribute('data-mv-hilfe-gruppen') || '').split(/\s+/);
      var ok = (filter === 'alle' || gruppen.indexOf(filter) !== -1) && passt(heuVon(k), sw);
      k.hidden = !ok;
      if (ok) zahl += 1;
      var liste = k.querySelector('[data-mv-hilfe-karte-treffer]');
      if (!liste) return;
      var treffer = false;
      alle(liste, '[data-mv-hilfe-treffer-schritt]').forEach(function (li) {
        var t = sw.length > 0 && passt(normalisiere(li.textContent).replace(/^schritt \d+ /, ''), sw);
        li.hidden = !t;
        if (t) treffer = true;
      });
      liste.hidden = !(ok && treffer);
    });
    alle(h, '[data-mv-hilfe-kategorie]').forEach(function (g) {
      g.hidden = !alle(g, '[data-mv-hilfe-karte]').some(function (k) { return !k.hidden; });
    });
    var kacheln = h.querySelector('[data-mv-hilfe-kacheln]');
    if (kacheln) kacheln.hidden = aktiv;
    alle(h, '[data-mv-hilfe-geraet]').forEach(function (c) {
      c.setAttribute('aria-pressed', c.getAttribute('data-mv-hilfe-geraet') === filter ? 'true' : 'false');
    });
    setzeText(h.querySelector('[data-mv-hilfe-treffer]'), trefferText(zahl, aktiv));
    var leer = h.querySelector('[data-mv-hilfe-leer]');
    if (leer) leer.hidden = !(aktiv && zahl === 0);
    var leeren = h.querySelector('[data-mv-hilfe-leeren]');
    if (leeren) leeren.hidden = !(feld && feld.value);
    klappAbgleich(h, aktiv);
  }

  function planen(h) {
    if (zeitgeber) window.clearTimeout(zeitgeber);
    zeitgeber = window.setTimeout(function () {
      zeitgeber = null;
      anwenden(h);
    }, VERZOEGERUNG);
  }

  function suchParameter() {
    try {
      var u = new URL(window.location.href);
      return String(u.searchParams.get('suche') || '').slice(0, 80);
    } catch (e) {
      return '';
    }
  }

  function hubStarten(h) {
    var karten = alle(h, '[data-mv-hilfe-karte]');
    karten.forEach(heuVon);
    karten.forEach(function (k) {
      var gesamt = parseInt(k.getAttribute('data-mv-hilfe-schritte'), 10) || 0;
      var n = anzahlErledigt(lade(k.getAttribute('data-mv-hilfe-karte')), gesamt);
      var p = k.querySelector('[data-mv-hilfe-karte-fortschritt]');
      if (p) {
        p.hidden = n === 0;
        setzeText(p, n ? kartenText(n, gesamt) : '');
      }
      if (n && n >= gesamt) k.setAttribute('data-mv-hilfe-zustand', 'erledigt');
      else k.removeAttribute('data-mv-hilfe-zustand');
    });
    var box = h.querySelector('[data-mv-hilfe-suche-box]');
    if (box) box.hidden = false;
    var feld = h.querySelector('[data-mv-hilfe-suche]');
    var vorgabe = suchParameter();
    if (feld && vorgabe && !feld.value) feld.value = vorgabe;
    if (!h.getAttribute('data-mv-hilfe-filter')) h.setAttribute('data-mv-hilfe-filter', 'alle');
    h.setAttribute('data-mv-hilfe-bereit', VERSION);
    anwenden(h);
    // Paket M-6b: unter 700 px Klappbereiche; ein Anker auf ein Thema ist danach offen und wird angesprungen
    if (abfrage && abfrage.matches) {
      klappAn(h);
      var ziel = ankerZiel();
      if (gruppeVon(h, ziel)) window.setTimeout(function () { springeZu(ziel, null, true); }, 0);
    }
  }

  function hubLeeren(h, fokus) {
    var feld = h.querySelector('[data-mv-hilfe-suche]');
    if (feld) feld.value = '';
    h.setAttribute('data-mv-hilfe-filter', 'alle');
    anwenden(h);
    if (fokus && feld && typeof feld.focus === 'function') feld.focus();
  }

  // ---------------------------------------------- Hub mobil: Themen einklappen (Paket M-6b)
  // Knopf = button direkt in .mv-hilfe-gruppe__titel, Inhalt = ul.mv-hilfe-karten (hidden, wenn zu). Das Skript merkt
  // sich Knopf, Zaehler und vergebene id am Element und sucht sie ueber Klassen, nicht ueber neue data-Attribute.

  function klappDaten(h) {
    if (!h.__mvHilfeKlapp) h.__mvHilfeKlapp = { zu: null, vorher: null, treffer: {}, manuell: false };
    return h.__mvHilfeKlapp;
  }

  function klappMerken(h, neu) {
    var st = klappDaten(h);
    st.zu = neu.zu;
    st.vorher = neu.vorher;
    st.treffer = neu.treffer;
    st.manuell = neu.manuell;
    return st;
  }

  function gruppenVon(h) {
    return alle(h, 'section[data-mv-hilfe-kategorie]');
  }

  function gruppeId(g) {
    return g.getAttribute('data-mv-hilfe-kategorie') || '';
  }

  function gruppeVon(h, el) {
    var g = el && el.closest ? el.closest('section[data-mv-hilfe-kategorie]') : null;
    return g && h.contains(g) ? g : null;
  }

  function gruppeKnopf(g) {
    var titel = g.querySelector('.mv-hilfe-gruppe__titel');
    var k = titel ? titel.lastElementChild : null;
    return k && k.__mvHilfeKlappe ? k : null;
  }

  function ankerZiel() {
    var id = String(window.location.hash || '').replace(/^#/, '');
    if (!id) return null;
    try { id = decodeURIComponent(id); } catch (e) { /* Anker roh verwenden */ }
    return document.getElementById(id);
  }

  function klappSetzen(g, offen) {
    var knopf = gruppeKnopf(g);
    var liste = g.querySelector('.mv-hilfe-karten');
    if (!knopf || !liste) return;
    liste.hidden = !offen;
    knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
  }

  // Ueberschrift -> Knopf mit Zahl der Anleitungen; die Kartenliste bekommt fuer aria-controls eine id
  function gruppeKlappbar(g) {
    var titel = g.querySelector('.mv-hilfe-gruppe__titel');
    var liste = g.querySelector('.mv-hilfe-karten');
    if (!titel || !liste || gruppeKnopf(g)) return;
    if (!liste.id) {
      liste.id = g.id + '-karten';
      liste.__mvHilfeId = true;
    }
    var knopf = document.createElement('button');
    knopf.setAttribute('type', 'button');
    knopf.setAttribute('aria-controls', liste.id);
    knopf.__mvHilfeKlappe = true;
    while (titel.firstChild) knopf.appendChild(titel.firstChild);
    var zahl = document.createElement('span');
    zahl.setAttribute('aria-hidden', 'true');
    knopf.__mvHilfeZahl = zahl;
    knopf.appendChild(zahl);
    titel.appendChild(knopf);
  }

  function gruppeZurueck(g) {
    var knopf = gruppeKnopf(g);
    var liste = g.querySelector('.mv-hilfe-karten');
    if (knopf) {
      var titel = knopf.parentNode;
      if (knopf.__mvHilfeZahl && knopf.__mvHilfeZahl.parentNode === knopf) knopf.removeChild(knopf.__mvHilfeZahl);
      while (knopf.firstChild) titel.insertBefore(knopf.firstChild, knopf);
      titel.removeChild(knopf);
    }
    if (liste) {
      liste.hidden = false;
      if (liste.__mvHilfeId) {
        liste.removeAttribute('id');
        liste.__mvHilfeId = false;
      }
    }
  }

  // Stand nach Suche und Filter fortschreiben und ins Markup uebertragen; Zahl = sichtbare Anleitungen des Themas
  function klappAbgleich(h, aktiv) {
    if (!h.hasAttribute('data-mv-hilfe-klapp')) return;
    var gruppen = gruppenVon(h);
    var treffer = {};
    gruppen.forEach(function (g) { treffer[gruppeId(g)] = !g.hidden; });
    var st = klappMerken(h, klappFolge(klappDaten(h), treffer, aktiv));
    gruppen.forEach(function (g) {
      klappSetzen(g, !st.zu[gruppeId(g)]);
      var knopf = gruppeKnopf(g);
      var n = alle(g, '[data-mv-hilfe-karte]').filter(function (k) { return !k.hidden; }).length;
      if (knopf && knopf.__mvHilfeZahl) setzeText(knopf.__mvHilfeZahl, String(n));
    });
  }

  function suchAktiv(h) {
    var feld = h.querySelector('[data-mv-hilfe-suche]');
    return woerter(feld ? feld.value : '').length > 0 || (h.getAttribute('data-mv-hilfe-filter') || 'alle') !== 'alle';
  }

  function klappAn(h) {
    if (h.hasAttribute('data-mv-hilfe-klapp')) return;
    var st = klappDaten(h);
    var gruppen = gruppenVon(h);
    if (st.zu === null) {
      var anker = gruppeVon(h, ankerZiel());
      var offen = startOffen(gruppen.map(gruppeId), anker ? gruppeId(anker) : '');
      st.zu = {};
      gruppen.forEach(function (g) { if (offen.indexOf(gruppeId(g)) === -1) st.zu[gruppeId(g)] = true; });
    }
    gruppen.forEach(gruppeKlappbar);
    h.setAttribute('data-mv-hilfe-klapp', '');
    klappAbgleich(h, suchAktiv(h));
  }

  // ab 700 px: Markup wie ohne M-6b, der Stand bleibt fuer den naechsten Wechsel
  function klappAus(h) {
    if (!h.hasAttribute('data-mv-hilfe-klapp')) return;
    gruppenVon(h).forEach(gruppeZurueck);
    h.removeAttribute('data-mv-hilfe-klapp');
  }

  // Thema aufklappen (Kachel, Anker); true, wenn es zu war
  function klappOeffnen(h, g) {
    if (!g || !h.hasAttribute('data-mv-hilfe-klapp')) return false;
    var st = klappDaten(h);
    if (!st.zu[gruppeId(g)]) return false;
    klappMerken(h, klappUmschalten(st, gruppeId(g)));
    klappSetzen(g, true);
    return true;
  }

  function springeZu(el, fokus, sofort) {
    if (fokus && typeof fokus.focus === 'function') {
      try { fokus.focus({ preventScroll: true }); } catch (e) { fokus.focus(); }
    }
    if (el && typeof el.scrollIntoView === 'function') el.scrollIntoView({ behavior: sofort || ruhig() ? 'auto' : 'smooth', block: 'start' });
  }

  // ------------------------------------------------------------------------------- Start und Ereignisse

  function starten(bereich) {
    if (!bereich || !bereich.querySelectorAll) return;
    var anleitungen = alle(bereich, '[data-mv-hilfe]');
    if (bereich.matches && bereich.matches('[data-mv-hilfe]')) anleitungen.unshift(bereich);
    anleitungen.forEach(anleitungStarten);
    var hubs = alle(bereich, '[data-mv-hilfe-hub]');
    if (bereich.matches && bereich.matches('[data-mv-hilfe-hub]')) hubs.unshift(bereich);
    hubs.forEach(hubStarten);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var knopf = t.closest('[data-mv-hilfe-erledigt]');
    if (knopf) {
      var w = wurzelVon(knopf);
      if (!w) return;
      e.preventDefault();
      schrittUmschalten(w, parseInt(knopf.getAttribute('data-mv-hilfe-erledigt'), 10));
      return;
    }
    var reset = t.closest('[data-mv-hilfe-zuruecksetzen]');
    if (reset && wurzelVon(reset)) {
      e.preventDefault();
      zuruecksetzen(wurzelVon(reset));
      return;
    }
    if (t.closest('[data-mv-hilfe-drucken]')) {
      e.preventDefault();
      vorDruck();
      if (typeof window.print === 'function') window.print();
      return;
    }
    var weg = t.closest('[data-mv-hilfe-gehe], [data-mv-hilfe-leiste-ziel], [data-mv-hilfe-start]');
    if (weg) {
      var href = weg.getAttribute('href') || '';
      if (href.charAt(0) === '#' && springe(href.slice(1))) e.preventDefault();
      return;
    }
    var h = hubVon(t);
    if (!h) return;
    var chip = t.closest('[data-mv-hilfe-geraet]');
    if (chip) {
      e.preventDefault();
      var neu = chip.getAttribute('data-mv-hilfe-geraet') || 'alle';
      if (neu === h.getAttribute('data-mv-hilfe-filter') && neu !== 'alle') neu = 'alle';
      h.setAttribute('data-mv-hilfe-filter', neu);
      anwenden(h);
      return;
    }
    if (t.closest('[data-mv-hilfe-alles]')) {
      e.preventDefault();
      hubLeeren(h, true);
      return;
    }
    if (t.closest('[data-mv-hilfe-leeren]')) {
      e.preventDefault();
      var feld = h.querySelector('[data-mv-hilfe-suche]');
      if (feld) feld.value = '';
      anwenden(h);
      if (feld && typeof feld.focus === 'function') feld.focus();
    }
  });

  document.addEventListener('change', function (e) {
    var feld = e.target;
    if (!feld || !feld.matches || !feld.matches('[data-mv-hilfe-haken]')) return;
    var w = wurzelVon(feld);
    if (!w) return;
    var handle = w.getAttribute('data-mv-hilfe');
    var neu = setzeHaken(lade(handle), feld.getAttribute('data-mv-hilfe-haken'), !!feld.checked);
    sichere(handle, neu);
    anleitungAnwenden(w, neu);
  });

  document.addEventListener('input', function (e) {
    var feld = e.target;
    if (!feld || !feld.matches || !feld.matches('[data-mv-hilfe-suche]')) return;
    var h = hubVon(feld);
    if (h) planen(h);
  });

  document.addEventListener('keydown', function (e) {
    var feld = e.target;
    if (e.key !== 'Escape' || !feld || !feld.matches || !feld.matches('[data-mv-hilfe-suche]') || !feld.value) return;
    e.preventDefault();
    feld.value = '';
    var h = hubVon(feld);
    if (h) anwenden(h);
  });

  window.addEventListener('beforeprint', vorDruck);
  window.addEventListener('afterprint', nachDruck);
  window.addEventListener('hashchange', oeffneAusHash);

  // ------------------------------------------------------------------------------- Hub mobil (Paket M-6b)

  // Klappknopf eines Themas; Kacheln und andere Links auf Anker der Seite oeffnen vorher das Zielthema
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var h = hubVon(t);
    if (!h || !h.hasAttribute('data-mv-hilfe-klapp')) return;
    var knopf = t.closest('.mv-hilfe-gruppe__titel > button');
    if (knopf && knopf.__mvHilfeKlappe) {
      e.preventDefault();
      var g = gruppeVon(h, knopf);
      if (!g) return;
      var st = klappMerken(h, klappUmschalten(klappDaten(h), gruppeId(g)));
      klappSetzen(g, !st.zu[gruppeId(g)]);
      return;
    }
    var a = t.closest('a[href^="#"]');
    if (a) klappOeffnen(h, gruppeVon(h, document.getElementById(a.getAttribute('href').slice(1))));
  });

  // Enter im Suchfeld: sofort anwenden, Fokus auf den Knopf des ersten Themas mit Treffern (schliesst die Tastatur)
  document.addEventListener('keydown', function (e) {
    var feld = e.target;
    if (e.key !== 'Enter' || e.isComposing || !feld || !feld.matches || !feld.matches('[data-mv-hilfe-suche]')) return;
    var h = hubVon(feld);
    if (!h || !h.hasAttribute('data-mv-hilfe-klapp')) return;
    e.preventDefault();
    if (zeitgeber) {
      window.clearTimeout(zeitgeber);
      zeitgeber = null;
    }
    anwenden(h);
    var erste = null;
    gruppenVon(h).forEach(function (g) { if (!erste && !g.hidden) erste = g; });
    if (erste) springeZu(erste, gruppeKnopf(erste), false);
  });

  // Anker ohne Klick (Zurueck, Adresse geaendert): Zielthema oeffnen und hinspringen
  window.addEventListener('hashchange', function () {
    var ziel = ankerZiel();
    var h = hubVon(ziel);
    if (!h || !h.hasAttribute('data-mv-hilfe-klapp')) return;
    if (klappOeffnen(h, gruppeVon(h, ziel))) springeZu(ziel, null, false);
  });

  // Seite drucken: alle Themen auf, danach der Stand von vorher
  window.addEventListener('beforeprint', function () {
    alle(document, '[data-mv-hilfe-hub]').forEach(function (h) {
      if (!h.hasAttribute('data-mv-hilfe-klapp')) return;
      h.__mvHilfeDruckOffen = true;
      gruppenVon(h).forEach(function (g) { klappSetzen(g, true); });
    });
  });
  window.addEventListener('afterprint', function () {
    alle(document, '[data-mv-hilfe-hub]').forEach(function (h) {
      if (!h.__mvHilfeDruckOffen) return;
      h.__mvHilfeDruckOffen = false;
      var st = klappDaten(h);
      gruppenVon(h).forEach(function (g) { klappSetzen(g, !st.zu[gruppeId(g)]); });
    });
  });

  // Wechsel ueber 700 px (Drehen, Fenster): Klappbereiche auf- bzw. zurueckbauen
  function grenzeGewechselt() {
    alle(document, '[data-mv-hilfe-hub]').forEach(function (h) {
      if (!h.hasAttribute('data-mv-hilfe-bereit')) return;
      if (abfrage.matches) klappAn(h);
      else klappAus(h);
    });
  }
  if (abfrage) {
    if (typeof abfrage.addEventListener === 'function') abfrage.addEventListener('change', grenzeGewechselt);
    else if (typeof abfrage.addListener === 'function') abfrage.addListener(grenzeGewechselt);
  }

  document.addEventListener('shopify:section:load', function (e) {
    starten(e.target);
  });

  api.anwenden = anwenden;
  api.starten = starten;
  MV.hilfe = api;

  function bereit() {
    starten(document);
    oeffneAusHash();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bereit);
  else bereit();
})();
